export var createTableColumns = function (dataSource, createProgressCellRender) {
    var ROOM_TYPE_NAME_MAX_LEN = 6;
    var renderRoomTypeName = function (label) {
        if (!label)
            return label;
        var s = String(label);
        if (s.length <= ROOM_TYPE_NAME_MAX_LEN)
            return s;
        return "".concat(s.slice(0, ROOM_TYPE_NAME_MAX_LEN), "..");
    };
    // 左:中:右 = 9:6:9（总 24 份）→ 37.5% : 25% : 37.5%，随表格外层宽度变化按比例分配
    var wLeft = "".concat((9 / 24) * 100, "%");
    var wMid = "".concat((6 / 24) * 100, "%");
    var wRight = "".concat((9 / 24) * 100, "%");
    return [
        { title: "房型", dataIndex: "label", key: "label", cellType: "text", width: wLeft, align: "right", render: function (val) { return renderRoomTypeName(val); } },
        { title: "房态", dataIndex: "quantityOpen", key: "roomStatus", width: wMid, align: "center", render: function (_, record) { var _a, _b; return "".concat((_a = record.quantityOpen) !== null && _a !== void 0 ? _a : 0, "/").concat((_b = record.quantity) !== null && _b !== void 0 ? _b : 0); } },
        { title: "出租率", dataIndex: "progress", key: "progress", width: wRight, render: createProgressCellRender && dataSource ? createProgressCellRender(dataSource) : undefined },
    ];
};
export var TABLE_CONFIG = {
    SIZE: "small",
    PAGINATION: false,
    SHOW_HEADER: false,
    BORDERED: false,
    SHOW_COLUMN_SETTING: false,
    AUTO_SCROLL: false,
};
